import L from 'leaflet'

// leaflet.heat@0.2.0 is a legacy global-style plugin: it assigns `L.heatLayer`
// onto a bare global `L`, with no import of its own. Since the Vite 8 (Rolldown)
// upgrade it no longer patches our ESM `leaflet` instance, so expose Leaflet on
// the global object here. This module must be imported BEFORE 'leaflet.heat' so
// the plugin patches the same instance the app uses.
;(globalThis as unknown as { L: typeof L }).L = L

export default L
